"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubmissionType = void 0;
var SubmissionType;
(function (SubmissionType) {
    SubmissionType[SubmissionType["TEXT"] = 0] = "TEXT";
    SubmissionType[SubmissionType["LOCATION"] = 1] = "LOCATION";
    SubmissionType[SubmissionType["GRADATION"] = 2] = "GRADATION";
    SubmissionType[SubmissionType["START_WORKING"] = 3] = "START_WORKING";
    SubmissionType[SubmissionType["STOP_WORKING"] = 4] = "STOP_WORKING";
    SubmissionType[SubmissionType["DOCUMENT"] = 5] = "DOCUMENT";
    SubmissionType[SubmissionType["QUESTIONNAIRE"] = 6] = "QUESTIONNAIRE";
})(SubmissionType = exports.SubmissionType || (exports.SubmissionType = {}));
//# sourceMappingURL=submissionType.enum.js.map